import CredentialsLayout from '../components/layouts/CredentialsLayout.vue';
import CredentialsIndexPage from '../pages/CredentialsIndexPage.vue';

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
    {
        // This is the parent route for your package.
        // It uses the layout component.
        path: '/credentials',
        name: 'credentials.root',
        component: CredentialsLayout,
        meta: {
            // e.g., requiresAuth: true
            // requiresAuth: true,
            // title: 'credentials.nav.title',
            // layout: 'Authenticated',
        },
        // All other package routes are children of this layout
        children: [
            {
                // Child path is empty, so it renders at /credentials
                path: '',
                name: 'CredentialsIndexPage',
                component: CredentialsIndexPage,
            },
            // --- Example of other child routes ---
            // {
            //   path: 'create', // Renders at /credentials/create
            //   name: 'credentials.create',
            //   component: () => import('../components/Create.vue'),
            // },
        ]
    }
];
